import type {FirebaseApp} from 'firebase/app';
import type {Auth as AuthType} from 'firebase/auth';
import type {Functions as FunctionType} from 'firebase/functions';
import type {Firestore as FirestoreType} from 'firebase/firestore';
import type {FirebaseStorage as StorageType} from 'firebase/storage';

import {initializeApp} from 'firebase/app';
import {getAuth, connectAuthEmulator} from 'firebase/auth';
import { getStorage, connectStorageEmulator} from 'firebase/storage';
import {getFirestore, connectFirestoreEmulator} from 'firebase/firestore';
import {getFunctions, connectFunctionsEmulator} from 'firebase/functions';

import {CONFIG} from 'src/global-config';

// ----------------------------------------------------------------------

const isFirebaseEmulator = CONFIG.firebae_emulator.host !== '';

const isFirebase = CONFIG.auth.method === 'firebase';

export const firebaseApp = isFirebase ? initializeApp(CONFIG.firebase) : ({} as FirebaseApp);

export const AUTH = isFirebase ? getAuth(firebaseApp) : ({} as AuthType);

export const FIRESTORE = isFirebase ? getFirestore(firebaseApp, CONFIG.firebase.databaseId) : ({} as FirestoreType);

export const STORAGE = isFirebase ?
  getStorage(firebaseApp, `gs://${CONFIG.firebase.storageBucket}`) : ({} as StorageType);

export const FUNCTIONS = isFirebase ? getFunctions(firebaseApp, "europe-west3") : ({} as FunctionType);

export const FUNCTIONS_URL = isFirebase ? CONFIG.firebase.functionsHttpUrl : '';

if (isFirebaseEmulator) {
  try {
    connectAuthEmulator(AUTH, `http://${CONFIG.firebae_emulator.host}:${CONFIG.firebae_emulator.auth_port}/`);
    connectFirestoreEmulator(FIRESTORE, CONFIG.firebae_emulator.host, CONFIG.firebae_emulator.firestore_port);
    connectStorageEmulator(STORAGE, CONFIG.firebae_emulator.host, CONFIG.firebae_emulator.storage_port);
    connectFunctionsEmulator(FUNCTIONS, CONFIG.firebae_emulator.host, CONFIG.firebae_emulator.functions_port)
  } catch (e) {
    console.log(e)
  }
}